import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { WelcomeMessagesQuery } from './WelcomeMessagesQuery.graphql';

export function preloadWelcomeMessages() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: WelcomeMessagesQuery,
	});
}
